const bodySelector = $("body");

const handleModalStart = () => {
  $(".js-modal-open").on("click", function(e) {
    const modalId = $(this).attr("data-target-modal");
    const animationStyle = $(this).attr("data-animation");
    if (animationStyle) {
      switch (animationStyle) {
        case "bg-slide-top":
          bodySelector.addClass("animation-bg-slide-top");
          break;
        case "bg-slide-left":
          bodySelector.addClass("animation-bg-slide-left");
          break;
        default:
          bodySelector.addClass("no-scrollable");
      }
    }

    if (!bodySelector.hasClass("no-scrollable")) {
      bodySelector.addClass("no-scrollable");
    }

    $(`#${modalId}`)
      .attr("aria-hidden", "false")
      .addClass("is-animated")
      .addClass("is-visible");

    $(`#${modalId}`)
      .find(".ui-tabs__labels")
      .css(
        "top",
        $(`#${modalId}`)
          .find(".ui-modal-header")
          .outerHeight()
      );
  });
};

const removeAnimationClasses = selector => {
  if (selector.attr("class")) {
    selector
      .attr("class")
      .split(" ")
      .forEach(className => {
        if (className.includes("animation")) {
          selector.removeClass(className);
        }
      });
  }
};

const handleModalClose = () => {
  $(".js-modal-close").on("click", function(e) {
    const $this = $(this);
    const currentModalSelector = $this.closest(".ui-modal");
    const currentModalId = currentModalSelector.attr("id");

    removeAnimationClasses(bodySelector);
    bodySelector.removeClass("no-scrollable");

    currentModalSelector.attr("aria-hidden", "true").removeClass("is-visible");
    if (currentModalId !== "formPreviewModal") {
      setTimeout(() => {
        currentModalSelector.removeClass("is-animated");
      }, 200);
    } else {
      currentModalSelector.removeClass("is-animated");
    }
    // if ($(`[data-target-modal='${currentModalId}']`).length) {
    //   $("html, body").animate(
    //     {
    //       scrollTop:
    //         $(`[data-target-modal='${currentModalId}']`).offset().top -
    //         $(window).height() / 2
    //     },
    //     0
    //   );
    // }
  });
};

export const openUiModal = (modalId, animationStyle = "basic") => {
  switch (animationStyle) {
    case "bg-slide-top":
      bodySelector.addClass("animation-bg-slide-top");
      break;
    case "bg-slide-left":
      bodySelector.addClass("animation-bg-slide-left");
      break;
    default:
      bodySelector.addClass("no-scrollable");
  }

  bodySelector.addClass("no-scrollable");
  $(`#${modalId}`)
    .attr("aria-hidden", "false")
    .addClass("is-animated is-visible");
};

export const closeUiModal = modalId => {
  removeAnimationClasses(bodySelector);
  bodySelector.removeClass("no-scrollable");
  $(`#${modalId}`).removeClass("is-visible");

  setTimeout(() => {
    $(`#${modalId}`)
      .attr("aria-hidden", "true")
      .removeClass("is-animated");
  }, 400);
};

export const initUiModal = () => {
  handleModalStart();
  handleModalClose();
};

export default initUiModal;
